// extracted by mini-css-extract-plugin
export var projectInformation = "ProjectInformation-module--project-information--3SyRW";
export var projectInformation__header = "ProjectInformation-module--project-information__header--1s0g2";
export var projectInformation__information = "ProjectInformation-module--project-information__information--1xfEF";
export var projectInformation__iconWrapper = "ProjectInformation-module--project-information__icon-wrapper--r2NZA";